import i18n from 'i18n'
import * as React from "react"
import { SelectAjaxSeeker } from "ui-seeker/core"
import { FORMAT_DATE_BACK, formatDate } from 'ui-seeker/utils'

import { SelectLoading } from "app/components/loading"
import { COMPETITION_URL } from 'app/@common/constants'


export default function SelectBoard({ section, ...props }) {

    if ((section === 'competition' || section === 'parity') && (!props.sites || !props.date || !props.occupancy || !props.nights)) return <SelectLoading />
    if (section === 'packages' && (!props.selectedRoute?.length || !props.sitePackageID.length || !props.date || !props.occupancy || !props.nights)) return <SelectLoading />

    const myProps = {
        urlAjax: COMPETITION_URL.BOARDS,
        placeholder: i18n.t('common:filters.allMealsPlan'),
        isClearable: true,
        icon: { icon: 'backpack' },
        extraParams: {
            roomID: props.room,
            id_rate: props.rate,
            dateRange: props.date,
            nights: props.nights, 
            occupancy: props.occupancy, 
            devices: props.devices,
            info: props.info,
            hotelID: props.hotels,
            ...props.selectedRoute?.length && { routes: props.selectedRoute },
            ...props.sitePackageID?.length ? { sitePackageID: props.sitePackageID } : { id_site: props.sites },
            ...props.refresh && { refresh_cache: props.refresh },
            ...section !== 'competition' && { idMainHotel: props.mainHotels },
            ...props.id_report_execution && { id_report_execution: props.id_report_execution },
            ...'id_main_hotel' in props && { id_main_hotel: props.id_main_hotel },
            ...props.date === 'custom' && {
                startDate: formatDate(props.customDates[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(props.customDates[1], { format: FORMAT_DATE_BACK })
            }
        },
        ...props
    }

    return <SelectAjaxSeeker {...myProps} />
}